/**
 * 语言配置 - 原生语言名称
 * 这些名称不会被国际化翻译，始终以各自的原生语言显示
 */
export const NATIVE_LANGUAGE_NAMES = {
  zh: '简体中文',
  zh_TW: '繁體中文',
  en: 'English',
  jp: '日本語',
  ko: '한국어',
  id: 'Bahasa Indonesia'
}

/**
 * 获取部署默认语言（从环境变量 VUE_APP_DEFAULT_LANG 读取）
 * @returns {string} 默认语言代码
 */
export function getDefaultLang() {
  const envLang = process.env.VUE_APP_DEFAULT_LANG
  if (envLang && NATIVE_LANGUAGE_NAMES[envLang]) {
    return envLang
  }
  return 'zh'
}

/**
 * 获取前端展示的语言列表（仅显示部署默认语言 + 英語）
 * @returns {Array<{code: string, nativeName: string}>}
 */
export function getAvailableLanguages() {
  const defaultLang = getDefaultLang()
  const codes = [defaultLang]
  if (defaultLang !== 'en') {
    codes.push('en')
  }
  return codes.map(code => ({
    code,
    nativeName: NATIVE_LANGUAGE_NAMES[code]
  }))
}

/**
 * 获取所有支持的语言列表
 * @returns {Array<{code: string, nativeName: string}>}
 */
export function getAllLanguages() {
  return Object.keys(NATIVE_LANGUAGE_NAMES).map(code => ({
    code,
    nativeName: NATIVE_LANGUAGE_NAMES[code]
  }))
}

/**
 * 获取语言的原生名称
 * @param {string} langCode 语言代码
 * @returns {string} 原生语言名称
 */
export function getNativeLanguageName(langCode) {
  return NATIVE_LANGUAGE_NAMES[langCode] || langCode
}

/**
 * 获取所有支持的语言列表
 * @returns {Array} 语言列表，包含code和nativeName
 */
export function getSupportedLanguages() {
  return getAllLanguages()
}